export const isOCI = (appName = '') => appName.toLowerCase() === 'oracle'
